


/**
 * Sets the theme for the application
 * @param {string} theme
 * **/
export function set_theme(theme) {
  window.localStorage.setItem("theme", theme)
  window.document.documentElement.className = "theme-" + theme
}




/**
 * Applies the theme on DOM content loaded
 * @param {string} theme
 * **/
export function apply_theme_onload(theme) {
  window.addEventListener("DOMContentLoaded", function () {
    const t = localStorage.getItem("theme") || theme
    set_theme(t)
  })
}


